import React from 'react';
import { SVGEmptyState } from '@brokerbay/design-components';
import styled from 'styled-components';
import { Text, Empty } from 'components';
import { useBreakpoint } from 'hooks';

const EmptyState: React.FC = () => {
  const { md } = useBreakpoint();
  return (
    <Empty
      image={<SVGEmptyState />}
      imageStyle={{
        height: '263px',
        marginTop: `${md ? 150 : 30}px`,
      }}
      description={<Text>No showing requests available</Text>}
      data-cy="no-showing-requests"
    />
  );
};

export default EmptyState;
